
<template>

  <div class="bldg-settings-outer">
    <div class="floor settings-floor" v-for="prop in bldgProps" v-if="!deleteBldg">
      <div class="floor-title">
        <h5>{{langTitle(prop.title)}}</h5>
      </div>
      <div class="expand-add">
        <h5 v-if="prop.prop !== 'country'">{{(prop.val && prop.val.length < 25 || $screen.breakpoint !== 'sm') ? prop.val : prop.val.substring(0, 22) + '...'}}</h5>
        <img v-else :src="prop.img" />
      </div>
    </div>
    <div class="floor crit-floor" style="justify-content:center;" v-if="!deleteBldg" @click="deleteBldg = true">
      <h5>{{clauses.del}}</h5>
    </div>
    <div class="floor settings-floor input-floor" v-if="deleteBldg">
      <input class="ob-input" v-model="delConfirm" />
    </div>
    <div class="floor settings-floor input-floor" v-if="deleteBldg">
      <h5>{{clauses.delConf}}</h5>
    </div>
    <div class="floor input-floor crit-floor" v-if="['delete', '削除'].includes(delConfirm.toLowerCase())" @click="$store.dispatch('destroyBldg')">
      <h5>{{clauses.delWarning}}</h5>
    </div>
    <div class="floor input-floor bad-floor" v-if="deleteBldg" @click="deleteBldg = false">
      <h5>{{clauses.cancel}}</h5>
    </div>
  </div>

</template>

<script>

import Lang from '@/lib/langTemplates/BuildingTemplate';

export default {

  data(){
    return {
      bldgProps: [],
      deleteBldg: false,
      delConfirm: ''
    }
  },

  computed: {
    bldg(){
      return this.$store.getters.getActiveBuilding();
    },
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    }
  },

  methods: {

    setBldgProps(){
      this.bldgProps = [
        {
          title: 'Address Ln 1',
          prop: 'street'
        },
        {
          title: 'Address Ln 2',
          prop: 'streetExtended'
        },
        {
          title: 'City',
          prop: 'city'
        },
        {
          title: 'State/Terr/Prov',
          prop: 'state'
        },
        {
          title: 'Postal Code',
          prop: 'zipCode'
        },
        {
          title: 'Country',
          prop: 'country',
          img: `https://catamphetamine.gitlab.io/country-flag-icons/3x2/${this.bldg.info.country}.svg`
        }
      ].map(i => {
        i.val = this.bldg.info[i.prop];
        return i;
      }).filter(x => x.val !== ' ');
    },

    langTitle(t){
      switch (t) {
        case 'Address Ln 1':
          return this.clauses.street;
        break;
        case 'Address Ln 2':
          return this.clauses.streetExtended;
        break;
        case 'City':
          return this.clauses.city;
        break;
        case 'State/Terr/Prov':
          return this.clauses.state;
        break;
        case 'Postal Code':
          return this.clauses.zipCode;
        break;
        case 'Country':
          return this.clauses.country;
        break;
      }
    }

  },

  mounted(){
    this.setBldgProps();
  }

}

</script>

<style>

.bldg-settings-outer {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.settings-floor {
  background-color: #435665;
  width: 100%;
  /* border-bottom: 1px solid lightgray; */
}

.settings-floor img {
  height: 25px;
}

.settings-floor .floor-title {
  width: 48%;
  height: 30px;
  justify-content: flex-start;
  margin-left: 2%;
}

.settings-floor .expand-add {
  width: 48%;
  justify-content: flex-end;
  margin-right: 2%;
  text-align: right;
}

.input-floor {
  justify-content: center;

}

.input-floor input {
  color: red;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/building/Settings.vue